import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enWelcome from "./locales/en/welcome.json";
import esWelcome from "./locales/es/welcome.json";

const resources = {
  en: { welcome: enWelcome },
  es: { welcome: esWelcome },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    defaultNS: "welcome",
    detection: {
      caches: ["localStorage"],
    },
  });

export default i18n;


